import React from 'react';
import { Link } from 'react-router-dom';

export function PrivacyNotice() {
  return (
    <p className="text-sm text-gray-500 text-center">
      By joining, you agree to our{' '}
      <Link to="/privacy" className="text-rose-500 hover:underline">
        Privacy Policy
      </Link>
      {' '}and{' '}
      <Link to="/terms" className="text-rose-500 hover:underline">
        Terms of Service
      </Link>
    </p>
  );
}